// Split out of EntityView.js: MoleculeImage.js and ProteinImage.js both need Ball,
// and EntityView.js imports both of them, which made EntityView.js<->MoleculeImage.js
// and EntityView.js<->ProteinImage.js circular imports.
export const Ball = ({className = "", title = "", text = "", scale = "lg"}) => (
  <div className={`${className ? className + ' ' : ""}ball ball-${scale}`}>
    <div>
      <span title={title || text || undefined}>{text || title || "???"}</span>
    </div>
  </div>
);
